import appConfig from '../config/appConfig';

const normalizeBase = (value) => {
  if (!value) return '';
  return String(value).replace(/\/+$/, '');
};

export const buildApiUrl = (path = '') => {
  const base = normalizeBase(appConfig?.apiBase || '');
  if (!path) {
    return base;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = String(path).replace(/^\/+/, '');
  return base ? `${base}/${normalizedPath}` : `/${normalizedPath}`;
};

export default buildApiUrl;
